import { DbSeparateReservation } from "../../../data/usecases/separate-reservation";
import { SeparateReservation } from "../../../domain/usecases/separate-reservation";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbSeparateReservation = (): SeparateReservation =>
  new DbSeparateReservation(
    makeApiUrl("/separation"),
    makeAuthorizeHttpClientDecorator()
  );
